// 转化数字格式 123123 -> 123,123
export function formatNumber(number: number) {
  const arr = String(number).split('.')
  let num = arr[0]
  let result = ''

  while (num.length > 3) {
    result = ',' + num.slice(-3) + result
    num = num.slice(0, num.length -3)
  }
  if (num.length > 0) result = num + result
  return arr[1] ? result + '.' + arr[1] : result
}